const DATA_GOVERNANCE_TAG_KEYS = new Set(['pfg-data-asset-owner']);
const RETIRED_ENTERPRISE_TAG_KEYS = new Set([
  'pfg-data-gov-metadata-exception',
]);

export const shouldShowEnterpriseTagLabel = (
  key: string,
  dataGovernanceTagsEnabled: boolean,
) => {
  const normalizedKey = key.toLowerCase();

  return (
    normalizedKey.startsWith('pfg') &&
    !RETIRED_ENTERPRISE_TAG_KEYS.has(normalizedKey) &&
    (dataGovernanceTagsEnabled || !DATA_GOVERNANCE_TAG_KEYS.has(normalizedKey))
  );
};
